<template>
  <div class="authx-preview">
    <div
      v-if="loading"
      v-loading="loading"
      class="authx-preview--loading"
    ></div>
    <template v-else>
      <nav class="authx-preview--nav">
        <h2>GetChat</h2>
        <div>
          <span class="mr-1"
            >Welcome {{ user && user.data && user.data.name }}</span
          >
          <el-button type="primary" @click="logout">Logout</el-button>
        </div>
      </nav>
      <div class="authx-preview--hero">
        <div class="authx-preview--hero__text">
          <span>A simple app</span>
          <h1>Dashboard</h1>
          <p>
            This is an authenticated page based on specified <br />redirect url
            in your app configuration
          </p>
        </div>
        <div class="authx-preview--hero__content">
          <pre>{{ json }}</pre>
        </div>
      </div>
    </template>
    <div class="authx-preview--note">
      <p>
        This is a sample redirect route after successful authentication via AuthX
      </p>
    </div>
  </div>
</template>

<script>
import apiConstants from "@/apiConstants";
export default {
  name: "AuthxPreviewRedirect",
  data() {
    return {
      loading: true,
      app: null,
      user: null,
      token: null
    };
  },
  computed: {
    appId() {
      return this.$route.params.id;
    },
    authx() {
      return window.authx ? window.authx : null;
    },
    json() {
      return `
      /**
      ** Upon user authentication, additional user data
      ** can be gotten using the AuthX API
      */
      {
        user: {...}
      }
     `;
    }
  },
  created() {
    this.getApp();
  },
  methods: {
    getApp() {
      this.loading = true;
      const apiUrl = `apps/${this.appId}`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (!resData) {
            this.loading = false;
            return;
          }
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.app = resData;
          }
          this.loading = false;
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.loading = false;
        });
    },
    logout() {
      this.$router.push({ name: "authx.preview.index", params: { id: this.appId } });
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/css/components/authx-preview.scss";

pre {
  font-size: 12px;
  background: #eee;
}
</style>
